import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Spinner, Alert, Badge, Modal } from 'react-bootstrap';
import api from '../../services/api';

const MoodSettings = () => {
  const [moods, setMoods] = useState([]);
  const [textarea, setTextarea] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchMoods();
  }, []);

  const fetchMoods = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/songs/settings/mood/list');
      const moodList = res.data.data || [];
      setMoods(moodList);
      setTextarea(moodList.join(','));
    } catch (err) {
      setError('Failed to load moods');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setMessage('');
    setError('');
    const moodArr = textarea.split(',').map(m => m.trim()).filter(Boolean);
    const formData = new FormData();
    moodArr.forEach((m, i) => formData.append(`moods[${i}]`, m));
    try {
      const res = await api.post('/songs/settings/mood/update', formData);
      setMessage(res.data.message || 'Updated!');
      if (res.data.success) {
        setMoods(moodArr);
        setShowModal(false);
      }
    } catch (err) {
      setError('Failed to update moods');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setTextarea(moods.join(','));
    setShowModal(true);
    setMessage('');
    setError('');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setMessage('');
    setError('');
  };

  return (
    <Card className="shadow-sm">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="mb-0">Moods</h2>
          <Button variant="primary" onClick={handleOpenModal} disabled={loading}>
            Update
          </Button>
        </div>
        {error && <Alert variant="danger" className="mb-3">{error}</Alert>}
        {message && <Alert variant="success" className="mb-3">{message}</Alert>}
        <div className="mb-3">
          {moods.length === 0 && <span className="text-muted">No moods found.</span>}
          {moods.map((mood, idx) => (
            <Badge key={mood + idx} bg="success" className="me-4 mb-2 p-2 text-dark">{mood}</Badge>
          ))}
        </div>
        <Modal show={showModal} onHide={handleCloseModal} centered scrollable fullscreen="sm-down">
          <Modal.Header closeButton>
            <Modal.Title>Edit Moods</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="mood-textarea">
                <Form.Label>Moods (comma separated)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  value={textarea}
                  onChange={e => setTextarea(e.target.value)}
                  disabled={loading}
                  placeholder="e.g. Happy,Sad,Excited"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal} disabled={loading}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSave} disabled={loading}>
              {loading ? <><Spinner animation="border" size="sm" className="me-2" />Saving...</> : 'Save'}
            </Button>
          </Modal.Footer>
        </Modal>
      </Card.Body>
    </Card>
  );
};

export default MoodSettings; 